import React, {PropTypes} from 'react';
import {reduxForm, Field } from 'redux-form';
import StandardField from 'shared/StandardField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import Submitting from 'shared/Submitting.jsx';

const CapacityAvailabilityForm = ({
  eventTypes,
  handleSubmit,
  onCancel,
  onSubmit,
  submitting,
  pristine
}) => (
  <form
    onSubmit={handleSubmit(onSubmit)}
    noValidate
  >

      <Field
        name="capacity"
        type="number"
        step="1"
        min="0"
        max="100"
        placeholder="Capacity (as a % of total)"
        component={StandardField}
      />
      <Field
        name="eventId"
        component={StandardSelectField}
        options={eventTypes}
        simpleValue
        placeholder="Event"
        searchable={false}
      />
      <Field
        name="startDate"
        type="date"
        placeholder="Start Date"
        component={StandardField}
      />
      <Field
        name="endDate"
        type="date"
        placeholder="End Date"
        component={StandardField}
      />
    <hr />
    <div className="form-group text-right">
        <button
          type="button"
          className="btn btn-link"
          disabled={submitting}
          onClick={onCancel}
        >Cancel</button>
        {` `}
        <button
          type="submit"
          className="btn btn-primary btn-lg"
          disabled={pristine || submitting}>
          {submitting ? <Submitting /> : <i className="fa fa-floppy-o" />} {`Update`}
          </button>
      </div>
  </form>
);

CapacityAvailabilityForm.propTypes = {
  eventTypes: PropTypes.arrayOf(PropTypes.object),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired
};

export default reduxForm({
  form: 'capacityAvailabilityForm'
})(CapacityAvailabilityForm);



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/CapacityAvailabilityForm.jsx